import React from "react"

import { AppInsuranceAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { insurance } from "@signals"


export default function AppCommonFiltersInsuranceAutocomplete({ ...props }) {
	return <AppInsuranceAutocomplete
		value={insurance.value}
		onChange={e => insurance.value = e.target.value}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/insurances`}
		{...props}
	/>
}